import rarities from '../../../../config/bite-card-rarities.json';
import type {BitePackId} from './bite-card-pack';
import './bite-card-odds.css';

export function BiteCardOdds({packId}:{packId?:BitePackId}) {
  const selected=rarities.find(item=>item.id===packId);
  return <section className="bite-card-odds" aria-label="카드 등급별 획득 확률">
    <h3>{selected?<>{selected.rarityKo} 카드 획득 확률 <strong>{selected.weight}%</strong></>:'카드 등급별 획득 확률'}</h3>
    <dl>{rarities.map(item=><div key={item.id} data-selected={item.id===packId||undefined}><dt>{item.rarityKo}</dt><dd>{item.weight}%</dd></div>)}</dl>
  </section>;
}
